import apiService from "services/api";

export const ProtectedLink = ({ href, label, ...props }) => (
    <a href={href + "?token=" + apiService.auth.token.get()} {...props}>
        {label}
    </a>
);
